export default {
  landingPage: 'LP',
  header: 'Header',
  footer: 'Footer',
  dashboard: 'Dashboard',
  connectionType: 'connectionType',
  createWallet: 'CW',
  accessWallet: 'AW',
  buyHardware: 'BH',
  exitDashboard: 'exitDashboard',
  networkSwitch: 'networkSwitch',
  gasSwitch: 'gasSwitch',
  swap: 'swapFlow',
  swapAmplitude: 'Swap',
  dapp: 'Dapp',
  swapTokenPair: 'swapTokenPair',
  swapToken: 'swapToken',
  globalError: 'globalError',
  enkrypt: 'enkrypt',
  mewwallet: 'mewwallet',
  buySell: 'BuySell',
  mewVersion: 'mewVersion',
  advertisement: 'MEWAd',
  nftModule: 'NftModule',
  staking: 'Staking',
  contract: 'Contract',
  trendingTokens: 'TrendingTokens'
};
